import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseChangeEvent } from '@nagel-types';
import { CUSTOM_FORM_ERRORS } from '../../formErrorsConsts';
import { MAX_FIELD_LENGTH } from '@nagel-consts';

@Component({
    selector: 'lib-textarea-field',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule
    ],
    templateUrl: './textarea-field.component.html',
    styleUrl: './textarea-field.component.scss',
})
export class TextareaFieldComponent {
    @Input() form!: FormGroup;
    @Input() key: string = '';
    @Input() value: string = '';
    @Input() className: string = '';
    @Input() label: string = '';
    @Input() placeholder: string = '';
    @Input() type: string = '';
    @Input() readonly: boolean = false;
    @Input() disabled: boolean = false;
    @Input() suffix: string = '';
    @Input() hint: string = '';
    @Input() maxLength: number = MAX_FIELD_LENGTH;
    @Input() onBlur: ((event: FocusEvent) => void) | undefined = undefined;
    @Input() onChange: ((event: BaseChangeEvent) => void) | undefined = undefined;

    control: FormControl | null = null;
    valueLength = 0;

    ngOnChanges() {
        this.valueLength = this.form.get(this.key)?.value?.length || 0;
    }


    handleOnInput(event: Event) {
        const value = (event.target as HTMLInputElement).value || '';
        this.valueLength = value.length;

        if (this.onChange) {
            this.onChange({ value, key: this.key });
        }
    }

    handleOnBlur(event: FocusEvent) {
        if (!this.onBlur) {
            return;
        }

        const hasFormError = this.form && this.getFormHasError();

        if (!this.form || !hasFormError) {
            this.onBlur(event);
        }
    };

    getFormHasError = () => {
        const fieldControl = this.form.get(this.key);

        return !!fieldControl?.errors && Object.keys(fieldControl.errors || {}).length;
    };

    getCustomError(control: AbstractControl | null): string | null {
        if (!control?.errors) { return null; }

        const customErrorKeys = Object.values(CUSTOM_FORM_ERRORS);

        const key = Object.keys(control.errors).find((errorKeys) =>
            customErrorKeys.includes(errorKeys)
        );

        return key ? control.errors[key] : null;
    }
}
